import React, { useState, useEffect, useReducer, useRef, useCallback } from "react";

import { isSameDay, parseISO, format } from "date-fns";
import openSocket from "../../services/socket-io";
import clsx from "clsx";

import { green } from "@material-ui/core/colors";
import {
  Button,
  Checkbox,
  CircularProgress,
  Divider,
  IconButton,
  makeStyles,
  Tooltip,
  Badge,
  Typography,
} from "@material-ui/core";
import {
  AccessTime,
  Block,
  BookmarkBorder,
  Bookmark,
  Done,
  DoneAll,
  ExpandMore,
  GetApp,
} from "@material-ui/icons";

import MarkdownWrapper from "../MarkdownWrapper";
import VcardPreview from "../VcardPreview";
import LocationPreview from "../LocationPreview";
import ModalImageCors from "../ModalImageCors";
import MessageOptionsMenu from "../MessageOptionsMenu";
//import whatsBackground from "../../assets/wa-background.png";
import useTicketCard from "../../hooks/useTicketCard";
import { i18n } from "../../translate/i18n";
//import whatsBackground from "../../assets/wa-background.png";

//import api from "../../services/api";
import toastError from "../../errors/toastError";
import toastSuccess from "../../errors/toastSuccess";
import api from "../../services/api";
import Audio from "../Audio";
import {getWaBackgroundImage} from "../../services/theme-service";


const whatsBackground = getWaBackgroundImage();

const useStyles = makeStyles((theme) => ({
  messagesListWrapper: {
    overflow: "hidden",
    position: "relative",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
  },

  messagesList: {
    backgroundImage: `url(${whatsBackground})`,
    backgroundSize: "cover",
    backgroundAttachment: "fixed",
    display: "flex",
    flexDirection: "column",
    flexGrow: 1,
    padding: "20px 20px 20px 20px",
    overflowY: "scroll",
    minHeight: "calc(100vh - 200px)", // Adicionando altura mínima para garantir que o background cubra toda a área
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "90px",
    },
    ...theme.scrollbarStyles,
  },

  circleLoading: {
    color: green[500],
    position: "absolute",
    opacity: "70%",
    top: 0,
    left: "50%",
    marginTop: 12,
  },

  messageLeft: {
    marginRight: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },

    whiteSpace: "pre-wrap",
    backgroundColor: "#ffffff",
    color: "#303030",
    alignSelf: "flex-start",
    borderTopLeftRadius: 0,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: "0 1px 1px #b3b3b3",
  },

  quotedContainerLeft: {
    margin: "-3px -80px 6px -6px",
    overflow: "hidden",
    backgroundColor: "#f0f0f0",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsg: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    display: "block",
    whiteSpace: "pre-wrap",
    overflow: "hidden",
  },

  quotedSideColorLeft: {
    flex: "none",
    width: "4px",
    backgroundColor: "#6bcbef",
  },

  messageRight: {
    marginLeft: 20,
    marginTop: 2,
    minWidth: 100,
    maxWidth: 600,
    height: "auto",
    display: "block",
    position: "relative",
    "&:hover #messageActionsButton": {
      display: "flex",
      position: "absolute",
      top: 0,
      right: 0,
    },

    whiteSpace: "pre-wrap",
    backgroundColor: "#dcf8c6",
    color: "#303030",
    alignSelf: "flex-end",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 0,
    paddingLeft: 5,
    paddingRight: 5,
    paddingTop: 5,
    paddingBottom: 0,
    boxShadow: "0 1px 1px #b3b3b3",
  },

  quotedContainerRight: {
    margin: "-3px -80px 6px -6px",
    overflowY: "hidden",
    backgroundColor: "#cfe9ba",
    borderRadius: "7.5px",
    display: "flex",
    position: "relative",
  },

  quotedMsgRight: {
    padding: 10,
    maxWidth: 300,
    height: "auto",
    whiteSpace: "pre-wrap",
  },

  quotedSideColorRight: {
    flex: "none",
    width: "4px",
    backgroundColor: "#35cd96",
  },

  messageActionsButton: {
    display: "none",
    position: "relative",
    color: "#999",
    zIndex: 1,
    backgroundColor: "inherit",
    opacity: "90%",
    "&:hover, &.Mui-focusVisible": { backgroundColor: "inherit" },
  },

  messageContactName: {
    display: "flex",
    color: "#6bcbef",
    fontWeight: 500,
  },

  textContentItem: {
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
  },

  textContentItemDeleted: {
    fontStyle: "italic",
    color: "rgba(0, 0, 0, 0.36)",
    overflowWrap: "break-word",
    padding: "3px 80px 6px 6px",
  },

  messageMedia: {
    objectFit: "cover",
    width: 250,
    height: 200,
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
    borderBottomLeftRadius: 8,
    borderBottomRightRadius: 8,
  },

  timestamp: {
    fontSize: 11,
    position: "absolute",
    bottom: 0,
    right: 5,
    color: "#999",
  },

  dailyTimestamp: {
    alignItems: "center",
    textAlign: "center",
    alignSelf: "center",
    width: "110px",
    backgroundColor: "#e1f3fb",
    margin: "10px",
    borderRadius: "10px",
    boxShadow: "0 1px 1px #b3b3b3",
  },

  dailyTimestampText: {
    color: "#808888",
    padding: 8,
    alignSelf: "center",
    marginLeft: "0px",
  },

  ackIcons: {
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  deletedIcon: {
    fontSize: 18,
    verticalAlign: "middle",
    marginRight: 4,
  },

  ackDoneAllIcon: {
    color: green[500],
    fontSize: 18,
    verticalAlign: "middle",
    marginLeft: 4,
  },

  downloadMedia: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "inherit",
    padding: 10,
  },

  messageWrapperSelected: {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: "10px",
  },

  messageSelectionButton: {
    position: "absolute",
    left: "-30px",
    top: "50%",
    transform: "translateY(-50%)",
    zIndex: 1,
  },

  selectionModeButtons: {
    display: "flex",
    justifyContent: "space-around",
    padding: theme.spacing(1),
    backgroundColor: "rgba(255, 255, 255, 0.9)",
    position: "sticky",
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 2,
  },

  selectionModeActive: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    padding: theme.spacing(1),
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    textAlign: "center",
    zIndex: 2,
  },
}));

const reducer = (state, action) => {
  if (action.type === "LOAD_MESSAGES") {
    const messages = action.payload;
    const newMessages = [];

    messages.forEach((message) => {
      const messageIndex = state.findIndex((m) => m.id === message.id);
      if (messageIndex !== -1) {
        state[messageIndex] = message;
      } else {
        newMessages.push(message);
      }
    });

    return [...newMessages, ...state];
  }

  if (action.type === "ADD_MESSAGE") {
    const newMessage = action.payload;
    
    // Verificar se a mensagem já existe no estado
    const messageIndex = state.findIndex((m) => m.id === newMessage.id);
    
    // Log detalhado para debug
    console.log("[DIAGNÓSTICO][Reducer] ADD_MESSAGE:", { 
      id: newMessage.id, 
      body: newMessage.body?.substring(0, 20), 
      exists: messageIndex !== -1 
    });

    if (messageIndex !== -1) {
      // Atualizar mensagem existente
      const updatedState = [...state];
      updatedState[messageIndex] = newMessage;
      return updatedState;
    } else {
      // Adicionar nova mensagem
      return [...state, newMessage];
    }
  }

  if (action.type === "UPDATE_MESSAGE") {
    const messageToUpdate = action.payload;
    const messageIndex = state.findIndex((m) => m.id === messageToUpdate.id);

    // Log detalhado para debug
    console.log("[DIAGNÓSTICO][Reducer] UPDATE_MESSAGE:", { 
      id: messageToUpdate.id, 
      found: messageIndex !== -1 
    });

    if (messageIndex !== -1) {
      const updatedState = [...state];
      updatedState[messageIndex] = messageToUpdate;
      return updatedState;
    }

    return state;
  }

  if (action.type === "RESET") {
    console.log("[DIAGNÓSTICO][Reducer] RESET");
    return [];
  }
  
  return state;
};

const MessagesList = ({ ticketId, isGroup, isPanelOpen }) => {
  const classes = useStyles();
  const { card, addMessageToContext, removeMessageFromContext } = useTicketCard(ticketId);

  const [messagesList, dispatch] = useReducer(reducer, []);
  const [pageNumber, setPageNumber] = useState(1);
  const [hasMore, setHasMore] = useState(false);
  const [loading, setLoading] = useState(false);
  const lastMessageRef = useRef();
  const socketRef = useRef(null);
  const messagesLoaded = useRef(false);
  const loadingTimeout = useRef(null);

  const [selectedMessage, setSelectedMessage] = useState({});
  const [anchorEl, setAnchorEl] = useState(null);
  const messageOptionsMenuOpen = Boolean(anchorEl);
  const currentTicketId = useRef(ticketId);
  
  // Estado para controlar o modo de seleção de mensagens para o contexto do Kanban
  const [selectionMode, setSelectionMode] = useState(false);
  const [selectedMessages, setSelectedMessages] = useState([]);
  const [cardMessages, setCardMessages] = useState([]);
  
  // Ao carregar o componente, buscar as mensagens que já estão no contexto do cartão
  useEffect(() => {
    if (card && card.cardMessages) {
      const messagesInContext = card.cardMessages.map(cm => cm.messageId);
      setCardMessages(messagesInContext);
    } else {
      setCardMessages([]);
    }
  }, [card]);

  // Função para limpar o estado ao trocar de chat
  const resetChat = useCallback(() => {
    console.log("[DIAGNÓSTICO] Resetando chat - ticketId:", ticketId);
    
    // Limpar timeout pendente para evitar condições de corrida
    if (loadingTimeout.current) {
      clearTimeout(loadingTimeout.current);
      loadingTimeout.current = null;
    }
    
    // Desconectar socket anterior se existir
    if (socketRef.current) {
      console.log("[DIAGNÓSTICO] Desconectando socket anterior");
      socketRef.current.disconnect();
      socketRef.current = null;
    }
    
    // Garantir que o estado é resetado antes de qualquer outra operação
    dispatch({ type: "RESET" });
    setPageNumber(1);
    messagesLoaded.current = false;
    
    // Atualizar referência do ticket atual
    currentTicketId.current = ticketId;
  }, [ticketId]);

  // Resetar estado quando o ticketId mudar
  useEffect(() => {
    resetChat();
  }, [ticketId, resetChat]);

  // Efeito para carregar mensagens do backend
  useEffect(() => {
    if (!ticketId) return;
    
    setLoading(true);
    
    // Usar uma referência para o timeout para poder cancelá-lo se necessário
    loadingTimeout.current = setTimeout(async () => {
      try {
        console.log("[DIAGNÓSTICO] Carregando mensagens para ticketId:", ticketId, "página:", pageNumber);
        
        const { data } = await api.get("/messages/" + ticketId, {
          params: { pageNumber },
        });

        // Verificar se o ticket atual ainda é o mesmo antes de atualizar o estado
        if (currentTicketId.current === ticketId) {
          console.log("[DIAGNÓSTICO] Mensagens carregadas:", data.messages.length);
          dispatch({ type: "LOAD_MESSAGES", payload: data.messages });
          setHasMore(data.hasMore);
          messagesLoaded.current = true;
          
          if (pageNumber === 1 && data.messages.length > 1) {
            scrollToBottom();
          }
        } else {
          console.log("[DIAGNÓSTICO] Ignorando mensagens - ticketId mudou");
        }
      } catch (err) {
        console.error("[DIAGNÓSTICO] Erro ao carregar mensagens:", err);
        toastError(err);
      } finally {
        setLoading(false);
        loadingTimeout.current = null;
      }
    }, 200); // Reduzindo o delay para melhorar a resposta
    
    return () => {
      if (loadingTimeout.current) {
        clearTimeout(loadingTimeout.current);
        loadingTimeout.current = null;
      }
    };
  }, [pageNumber, ticketId]);

  // Efeito para conectar ao socket e receber mensagens em tempo real
  useEffect(() => {
    // Não conectar ao socket se não houver ticketId ou se as mensagens não foram carregadas
    if (!ticketId || !messagesLoaded.current) return;
    
    console.log("[DIAGNÓSTICO] Inicializando socket para ticketId:", ticketId);
    
    // Garantir que qualquer socket anterior seja desconectado
    if (socketRef.current) {
      console.log("[DIAGNÓSTICO] Desconectando socket existente antes de criar novo");
      socketRef.current.disconnect();
      socketRef.current = null;
    }
    
    const connectAndSubscribe = () => {
      // Criar nova instância de socket
      socketRef.current = openSocket();
      
      console.log("[DIAGNÓSTICO][Socket] Conectando ao socket para ticketId:", ticketId);
      
      socketRef.current.on("connect", () => {
        console.log("[DIAGNÓSTICO][Socket] Conectado com ID:", socketRef.current.id);
        
        // Verificar novamente se o ticket ainda é o mesmo
        if (currentTicketId.current === ticketId) {
          socketRef.current.emit("joinChatBox", ticketId);
          console.log("[DIAGNÓSTICO][Socket] Entrou na sala ticketId:", ticketId);
        } else {
          console.log("[DIAGNÓSTICO][Socket] Não entrou na sala - ticketId mudou");
          socketRef.current.disconnect();
        }
      });

      socketRef.current.on("connect_error", (error) => {
        console.error("[DIAGNÓSTICO][Socket] Erro na conexão:", error);
        // Tentar reconectar após 3 segundos apenas se o ticketId ainda for o mesmo
        if (currentTicketId.current === ticketId) {
          setTimeout(connectAndSubscribe, 3000);
        }
      });

      socketRef.current.on("disconnect", (reason) => {
        console.warn("[DIAGNÓSTICO][Socket] Desconectado:", reason);
        if (reason === 'io server disconnect' || reason === 'transport close') {
          // Tentar reconectar automaticamente se for um problema do servidor
          if (currentTicketId.current === ticketId) {
            setTimeout(connectAndSubscribe, 3000);
          }
        }
      });

      socketRef.current.on("appMessage", (data) => {
        console.log("[DIAGNÓSTICO][Socket] Evento appMessage recebido:", {
          action: data.action,
          messageId: data.message?.id,
          ticketId: data.ticket?.id,
          messageBody: data.message?.body?.substring(0, 20) + (data.message?.body?.length > 20 ? '...' : '')
        });
        
        // Verificação mais rigorosa para garantir que estamos processando as mensagens corretas
        if (!data.message || !data.ticket) {
          console.warn("[DIAGNÓSTICO][Socket] Dados de mensagem inválidos:", data);
          return;
        }
        
        // Verificar se a mensagem é para o ticket atual
        if (data.ticket.id !== parseInt(ticketId) || currentTicketId.current !== ticketId) {
          console.log("[DIAGNÓSTICO][Socket] Mensagem ignorada - não é para o ticket atual");
          return;
        }
        
        if (data.action === "create") {
          console.log("[DIAGNÓSTICO][Socket] Adicionando nova mensagem:", data.message.id);
          
          // Verificar duplicação antes de adicionar
          const isDuplicate = messagesList.some(msg => msg.id === data.message.id);
          if (!isDuplicate) {
            console.log("[DIAGNÓSTICO][Socket] Dispatch ADD_MESSAGE:", data.message.id);
            dispatch({ type: "ADD_MESSAGE", payload: data.message });
            scrollToBottom();
          } else {
            console.log("[DIAGNÓSTICO][Socket] Mensagem duplicada ignorada:", data.message.id);
          }
        }

        if (data.action === "update") {
          console.log("[DIAGNÓSTICO][Socket] Atualizando mensagem:", data.message.id);
          dispatch({ type: "UPDATE_MESSAGE", payload: data.message });
        }
      });
    };

    // Pequeno atraso para garantir que o estado foi completamente resetado
    // antes de conectar ao novo socket
    const socketInitTimeout = setTimeout(() => {
      if (currentTicketId.current === ticketId) {
        connectAndSubscribe();
      }
    }, 100);

    return () => {
      clearTimeout(socketInitTimeout);
      if (socketRef.current) {
        console.log("[DIAGNÓSTICO][Socket] Desconectando socket na desmontagem");
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, [ticketId, messagesList, messagesLoaded.current]);

  // Efeito para forçar a atualização da lista de mensagens quando o ticketId mudar
  useEffect(() => {
    if (ticketId && messagesLoaded.current) {
      console.log("[DIAGNÓSTICO] Forçando atualização do DOM para o ticketId:", ticketId);
      
      // Forçar o navegador a renderizar a lista antes de continuar
      const forceRender = () => {
        const messagesListElement = document.getElementById("messagesList");
        if (messagesListElement) {
          // Pequena alteração no DOM para forçar uma re-renderização
          messagesListElement.style.opacity = "0.99";
          setTimeout(() => {
            messagesListElement.style.opacity = "1";
          }, 50);
        }
      };
      
      // Pequeno atraso para garantir que a mudança de DOM ocorre após a atualização do estado
      setTimeout(forceRender, 200);
    }
  }, [ticketId, messagesLoaded.current]);

  const loadMore = () => {
    setPageNumber((prevPageNumber) => prevPageNumber + 1);
  };

  const scrollToBottom = () => {
    if (lastMessageRef.current) {
      lastMessageRef.current.scrollIntoView({});
    }
  };

  const handleScroll = (e) => {
    if (!hasMore) return;
    const { scrollTop } = e.currentTarget;

    if (scrollTop === 0) {
      document.getElementById("messagesList").scrollTop = 1;
    }

    if (loading) {
      return;
    }

    if (scrollTop < 50) {
      loadMore();
    }
  };

  const handleOpenMessageOptionsMenu = (e, message) => {
    if (selectionMode) {
      // No modo de seleção, clicar na mensagem vai selecioná-la
      handleMessageSelection(message);
    } else {
      // No modo normal, abre o menu de opções
      setAnchorEl(e.currentTarget);
      setSelectedMessage(message);
    }
  };
  
  const handleCloseMessageOptionsMenu = () => {
    setAnchorEl(null);
  };

  // Função para lidar com a seleção de mensagens
  const handleMessageSelection = (message) => {
    const isSelected = selectedMessages.some(m => m.id === message.id);
    
    if (isSelected) {
      setSelectedMessages(selectedMessages.filter(m => m.id !== message.id));
    } else {
      setSelectedMessages([...selectedMessages, message]);
    }
  };
  
  // Verifica se uma mensagem está no contexto do cartão
  const isMessageInContext = (messageId) => {
    return cardMessages.includes(messageId);
  };
  
  // Função para ativar/desativar o modo de seleção
  const toggleSelectionMode = () => {
    setSelectionMode(!selectionMode);
    setSelectedMessages([]);
  };
  
  // Função para adicionar as mensagens selecionadas ao contexto do cartão
  const handleAddSelectedToContext = async () => {
    if (!card) {
      toastError(i18n.t("ticketCard.noCardError"));
      return;
    }
    
    try {
      for (const message of selectedMessages) {
        await addMessageToContext(message.id);
      }
      
      // Atualizar o estado local após adicionar as mensagens
      setCardMessages([...cardMessages, ...selectedMessages.map(m => m.id)]);
      setSelectedMessages([]);
      setSelectionMode(false);
      toastSuccess(i18n.t("ticketCard.messagesAddedToContext"));
    } catch (err) {
      toastError(err);
    }
  };
  
  // Função para remover uma mensagem do contexto
  const handleRemoveFromContext = async (messageId) => {
    try {
      await removeMessageFromContext(messageId);
      
      // Atualizar o estado local após remover a mensagem
      setCardMessages(cardMessages.filter(id => id !== messageId));
      toastSuccess(i18n.t("ticketCard.messageRemovedFromContext"));
    } catch (err) {
      toastError(err);
    }
  };

  const checkMessageMedia = (message) => {
    if (message.mediaType === "location" && message.body.split('|').length >= 2) {
      let locationParts = message.body.split('|')
      let imageLocation = locationParts[0]
      let linkLocation = locationParts[1]

      let descriptionLocation = null

      if (locationParts.length > 2)
        descriptionLocation = message.body.split('|')[2]

      return <LocationPreview image={imageLocation} link={linkLocation} description={descriptionLocation} />
    }
    else if (message.mediaType === "vcard") {
      //console.log("vcard")
      //console.log(message)
      let array = message.body.split("\n");
      let obj = [];
      let contact = "";
      for (let index = 0; index < array.length; index++) {
        const v = array[index];
        let values = v.split(":");
        for (let ind = 0; ind < values.length; ind++) {
          if (values[ind].indexOf("+") !== -1) {
            obj.push({ number: values[ind] });
          }
          if (values[ind].indexOf("FN") !== -1) {
            contact = values[ind + 1];
          }
        }
      }
      return <VcardPreview contact={contact} numbers={obj[0]?.number} />
    }
    /*else if (message.mediaType === "multi_vcard") {
      console.log("multi_vcard")
      console.log(message)
    	
      if(message.body !== null && message.body !== "") {
        let newBody = JSON.parse(message.body)
        return (
          <>
            {
            newBody.map(v => (
              <VcardPreview contact={v.name} numbers={v.number} />
            ))
            }
          </>
        )
      } else return (<></>)
    }*/
    else if ( /^.*\.(jpe?g|png|gif)?$/i.exec(message.mediaUrl) && message.mediaType === "image") {
      return <ModalImageCors imageUrl={message.mediaUrl} />;
    } else if (message.mediaType === "audio") {
      return <Audio url={message.mediaUrl} />
    } else if (message.mediaType === "video") {
      return (
        <video
          className={classes.messageMedia}
          src={message.mediaUrl}
          controls
        />
      );
    } else {
      return (
        <>
          <div className={classes.downloadMedia}>
            <Button
              startIcon={<GetApp />}
              color="primary"
              variant="outlined"
              target="_blank"
              href={message.mediaUrl}
            >
              Download
            </Button>
          </div>
          <Divider />
        </>
      );
    }
  };

  const renderMessageAck = (message) => {
    if (message.ack === 0) {
      return <AccessTime fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 1) {
      return <Done fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 2) {
      return <DoneAll fontSize="small" className={classes.ackIcons} />;
    }
    if (message.ack === 3 || message.ack === 4) {
      return <DoneAll fontSize="small" className={classes.ackDoneAllIcon} />;
    }
  };

  const renderDailyTimestamps = (message, index) => {
    if (index === 0) {
      return (
        <span
          className={classes.dailyTimestamp}
          key={`timestamp-${message.id}`}
        >
          <div className={classes.dailyTimestampText}>
            {format(parseISO(messagesList[index].createdAt), "dd/MM/yyyy")}
          </div>
        </span>
      );
    }
    if (index < messagesList.length - 1) {
      let messageDay = parseISO(messagesList[index].createdAt);
      let previousMessageDay = parseISO(messagesList[index - 1].createdAt);

      if (!isSameDay(messageDay, previousMessageDay)) {
        return (
          <span
            className={classes.dailyTimestamp}
            key={`timestamp-${message.id}`}
          >
            <div className={classes.dailyTimestampText}>
              {format(parseISO(messagesList[index].createdAt), "dd/MM/yyyy")}
            </div>
          </span>
        );
      }
    }
    if (index === messagesList.length - 1) {
      return (
        <div
          key={`ref-${message.createdAt}`}
          ref={lastMessageRef}
          style={{ float: "left", clear: "both" }}
        />
      );
    }
  };

  const renderMessageDivider = (message, index) => {
    if (index < messagesList.length && index > 0) {
      let messageUser = messagesList[index].fromMe;
      let previousMessageUser = messagesList[index - 1].fromMe;

      if (messageUser !== previousMessageUser) {
        return (
          <span style={{ marginTop: 16 }} key={`divider-${message.id}`}></span>
        );
      }
    }
  };

  const renderQuotedMessage = (message) => {
    return (
      <div
        className={clsx(classes.quotedContainerLeft, {
          [classes.quotedContainerRight]: message.fromMe,
        })}
      >
        <span
          className={clsx(classes.quotedSideColorLeft, {
            [classes.quotedSideColorRight]: message.quotedMsg?.fromMe,
          })}
        ></span>
        <div className={classes.quotedMsg}>
          {!message.quotedMsg?.fromMe && (
            <span className={classes.messageContactName}>
              {message.quotedMsg?.contact?.name}
            </span>
          )}
          {message.quotedMsg?.body}
        </div>
      </div>
    );
  };

  const renderMessages = () => {
    if (messagesList.length > 0) {
      const viewMessagesList = messagesList.map((message, index) => {
        // Verifica se a mensagem está selecionada
        const isSelected = selectedMessages.some(m => m.id === message.id);
        // Verifica se a mensagem está no contexto do cartão
        const inContext = isMessageInContext(message.id);
        
        if (!message.fromMe) {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderMessageDivider(message, index)}
              <div 
                className={clsx(classes.messageLeft, {
                  [classes.messageWrapperSelected]: isSelected || (selectionMode && inContext)
                })}
                onClick={selectionMode ? () => handleMessageSelection(message) : undefined}
              >
                {selectionMode && (
                  <Checkbox
                    className={classes.messageSelectionButton}
                    checked={isSelected}
                    onChange={() => handleMessageSelection(message)}
                    color="primary"
                  />
                )}
                
                {!selectionMode && inContext && (
                  <Tooltip title={i18n.t("ticketCard.panel.removeFromContext")}>
                    <IconButton
                      className={classes.messageSelectionButton}
                      size="small"
                      onClick={() => handleRemoveFromContext(message.id)}
                      color="secondary"
                    >
                      <Bookmark fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
                
                <IconButton
                  variant="contained"
                  size="small"
                  id="messageActionsButton"
                  disabled={message.isDeleted}
                  className={classes.messageActionsButton}
                  onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
                >
                  <ExpandMore />
                </IconButton>
                {isGroup && (
                  <span className={classes.messageContactName}>
                    {message.contact?.name}
                  </span>
                )}
                {(message.mediaUrl || message.mediaType === "location" || message.mediaType === "vcard"
                  //|| message.mediaType === "multi_vcard" 
                ) && checkMessageMedia(message)}
                <div className={classes.textContentItem}>
                  {message.quotedMsg && renderQuotedMessage(message)}
                  <MarkdownWrapper>{message.body}</MarkdownWrapper>
                  <span className={classes.timestamp}>
                    {format(parseISO(message.createdAt), "HH:mm")}
                  </span>
                </div>
              </div>
            </React.Fragment>
          );
        } else {
          return (
            <React.Fragment key={message.id}>
              {renderDailyTimestamps(message, index)}
              {renderMessageDivider(message, index)}
              <div 
                className={clsx(classes.messageRight, {
                  [classes.messageWrapperSelected]: isSelected || (selectionMode && inContext)
                })}
                onClick={selectionMode ? () => handleMessageSelection(message) : undefined}
              >
                {selectionMode && (
                  <Checkbox
                    className={classes.messageSelectionButton}
                    checked={isSelected}
                    onChange={() => handleMessageSelection(message)}
                    color="primary"
                  />
                )}
                
                {!selectionMode && inContext && (
                  <Tooltip title={i18n.t("ticketCard.panel.removeFromContext")}>
                    <IconButton
                      className={classes.messageSelectionButton}
                      size="small"
                      onClick={() => handleRemoveFromContext(message.id)}
                      color="secondary"
                    >
                      <Bookmark fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
                
                <IconButton
                  variant="contained"
                  size="small"
                  id="messageActionsButton"
                  disabled={message.isDeleted}
                  className={classes.messageActionsButton}
                  onClick={(e) => handleOpenMessageOptionsMenu(e, message)}
                >
                  <ExpandMore />
                </IconButton>
                {(message.mediaUrl || message.mediaType === "location" || message.mediaType === "vcard"
                  //|| message.mediaType === "multi_vcard" 
                ) && checkMessageMedia(message)}
                <div
                  className={clsx(classes.textContentItem, {
                    [classes.textContentItemDeleted]: message.isDeleted,
                  })}
                >
                  {message.isDeleted && (
                    <Block
                      color="disabled"
                      fontSize="small"
                      className={classes.deletedIcon}
                    />
                  )}
                  {message.quotedMsg && renderQuotedMessage(message)}
                  <MarkdownWrapper>{message.body}</MarkdownWrapper>
                  <span className={classes.timestamp}>
                    {format(parseISO(message.createdAt), "HH:mm")}
                    {renderMessageAck(message)}
                  </span>
                </div>
              </div>
            </React.Fragment>
          );
        }
      });
      return viewMessagesList;
    } else {
      return <div>Say hello to your new contact!</div>;
    }
  };

  return (
    <div className={classes.messagesListWrapper}>
      {selectionMode && (
        <div className={classes.selectionModeActive}>
          <Typography variant="body2">
            {i18n.t("ticketCard.selectionModeActive", { count: selectedMessages.length })}
          </Typography>
        </div>
      )}
      
      <MessageOptionsMenu
        message={selectedMessage}
        anchorEl={anchorEl}
        menuOpen={messageOptionsMenuOpen}
        handleClose={handleCloseMessageOptionsMenu}
      />
      
      <div
        id="messagesList"
        className={classes.messagesList}
        onScroll={handleScroll}
      >
        {messagesList.length > 0 ? renderMessages() : []}
      </div>
      
      {loading && (
        <div>
          <CircularProgress className={classes.circleLoading} />
        </div>
      )}
      
      {card && isPanelOpen && (
        <div className={classes.selectionModeButtons}>
          {!selectionMode ? (
            <Button
              variant="outlined"
              color="primary"
              startIcon={<BookmarkBorder />}
              onClick={toggleSelectionMode}
            >
              {i18n.t("ticketCard.panel.selectMessages")}
            </Button>
          ) : (
            <>
              <Button
                variant="outlined"
                color="secondary"
                onClick={toggleSelectionMode}
              >
                {i18n.t("ticketCard.panel.cancelSelection")}
              </Button>
              
              <Button
                variant="contained"
                color="primary"
                startIcon={<Bookmark />}
                onClick={handleAddSelectedToContext}
                disabled={selectedMessages.length === 0}
              >
                {i18n.t("ticketCard.panel.addSelectedToContext", { count: selectedMessages.length })}
              </Button>
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default MessagesList;